export default __webpack_public_path__ + "static/media/2.862e6eec.mp4";